import React from 'react';
import PropTypes from 'prop-types';
import {
  BooleanInput,
  TextInput,
  SimpleForm,
  DateInput,
  required,
  usePermissions,
} from 'react-admin';
import { CleanerAutocompleteInput, Toolbar } from '../../../../components';
import { getUser } from '../../../../user';

const Form = ({ aside, ...props }) => {
  const user = getUser();
  const today = new Date();
  // Fail closed: rely on react-admin permissions, fall back to the stored
  // user while the async AUTH_GET_PERMISSIONS call hasn't resolved yet (same
  // repli pattern as Cleaner/detail/Form.js and
  // Vivier/components/WarningsCard.js). Named `permissionsUser` here because
  // `user` already denotes the currently logged-in user, used above for
  // `validateur_id`.
  const { permissions } = usePermissions();
  const permissionsUser = permissions || getUser();

  // Mirror the server-side check (postgRest.js: hasPermission(user,
  // 'formation', 'delete', 1)) instead of a hardcoded role test, same motif
  // as Cleaner/detail/Form.js. `isCreate` keeps the button off the Create
  // screen (this Form is shared by Formation/Create.js and
  // Formation/Edit.js).
  const isCreate = !props.record || !props.record.id;
  const isDeletable =
    !isCreate && !!(permissionsUser?.permissions?.formation?.delete >= 1);

  return (
    <SimpleForm
      {...props}
      redirect="list"
      toolbar={<Toolbar isDeletable={isDeletable} />}
    >
      <CleanerAutocompleteInput validate={[required()]} />
      <DateInput source="date" />
      <TextInput source="intitule" />
      <TextInput source="description" />
      <BooleanInput source="certifiante" />
      <BooleanInput source="interne" />
      <TextInput source="commentaire" />
      <TextInput source="lien_detail" />
      <TextInput source="validateur_id" disabled defaultValue={user.id} />
      <DateInput
        source="last_modification_date"
        label="Dernière Modification"
        disabled
        defaultValue={today}
      />
    </SimpleForm>
  );
};

Form.propTypes = {
  aside: PropTypes.element,
};

Form.defaultProps = {
  aside: null,
};

export default Form;
